import React from "react";
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import './SomosVolteon.css';

const Reembolso = () => {
    return (
        <div>
            <Header></Header>
            <div className="volteon-container">
                <div className="volteon-content">
                    <h1>Reembolsos</h1>
                    <p>
                        Las políticas de cambio y reembolso de Volteon varían según el tipo de componente
                        adquirido, dependiendo de su naturaleza y la garantía que puedan llegar a tener según
                        su tiempo de uso. Es importante aclarar que para cualquier reclamación el cliente se
                        deberá contactar mediante WhatsApp para coordinar la inspección y posible cambio
                        o reembolso del producto.

                    </p>
                    <p>
                        La inspección de los productos se llevará a cabo por nuestros especialistas, quienes
                        se encargarán de escuchar al cliente, recoger el artículo y revisarlo meticulosamente
                        para determinar la causa del fallo y así determinar si se puede proceder con un
                        reembolso o un cambio para el determinado producto.
                        A continuación, las diferentes categorías:

                    </p>
                    
                    <h2> Componentes pequeños    </h2>
                    <p>
                        Los componentes pequeños que no superen un precio de 1000 colones, tales como
                        resistencias, capacitores, potenciómetros, diodos, transistores de cualquier tipo, relés,
                        leds y botones de cualquier tipo, no cuentan con reembolso o cambio. Esto debido
                        a que, por las características de los productos, es imposible determinar si el daño fue
                        de fábrica o causado por el cliente. Naturalmente, la excepción se presenta si al
                        momento de la entrega, el componente se encuentra visiblemente perjudicado
                        (terminales dobladas o rotas, corrosión o fractura en alguna de sus partes), en cuyo
                        caso se ejecuta inmediatamente el cambio por uno en mejores condiciones.

                    </p>
                    <p>

                        En el caso de los circuitos integrados, tales como las compuertas lógicas y los
                        amplificadores operaciones, habrá un período de 3 días naturales desde el día de la
                        entrega para reclamaciones. Para este tipo de productos únicamente aplica el cambio.


                    </p>
                    <h2> Prototipado </h2>
                    <p>
                        Para los componentes dentro de la categoría de prototipado de nuestra página web,
                        existirá un período de 7 días naturales desde el día de la entrega para efectuar
                        reclamaciones. Para este tipo de productos únicamente aplica el cambio. No aplica
                        para jumpers de cualquier tipo, puentes, lagartos o tubo termocontraíble, para los
                        cuales se admitirán reclamaciones únicamente al momento de la entrega.

                    </p>
                    <h2>Sensores, motores, pantallas y módulos</h2>
                    <p>
                        Para todos los componentes que se encuentren dentro de esta categoría, existirá un
                        período de garantía de 14 días naturales desde el día de la entrega para efectuar
                        reclamaciones. En este caso en específico, es importante documentar mediante
                        fotografías y videos al componente mal funcionando, en pro de realizar un
                        diagnóstico correcto al inspeccionarlo. Para este tipo de productos aplican tanto el
                        cambio como el reembolso.
                    </p>
                    <h2> Placas de desarrollo</h2>
                    <p>
                        Para todas las placas de desarrollo que ofrece Volteon Electronics en su catálogo,
                        existirá un período de garantía de 28 días naturales desde el día de la entrega para
                        efectuar reclamaciones. En este caso en específico, es importante documentar
                        mediante fotografías y videos a la placa mal funcionando, en pro de realizar un
                        diagnóstico correcto al inspeccionarlo. Además, la inspección de las placas de
                        desarrollo se realiza a mayor profundidad, por lo que se llevarán a cabo distintas
                        pruebas con la misma antes de ofrecer una respuesta. Para este tipo de productos
                        aplican tanto el cambio como el reembolso.
                        
                    </p>
                    
                    <h2>Kits</h2>
                    <p>
                        Para todos los distintos kits que ofrece Volteon Electronics en su catálogo, existirá
                        un período de 3 días naturales desde el día de la entrega para efectuar reclamaciones
                        acerca de su contenido. Es necesario documentar mediante fotografías el contenido
                        completo del kit, con el fin de determinar adecuadamente los componentes faltantes.
                        Para este tipo de productos aplica únicamente el cambio.
                        
                    </p>
                </div>
            </div>

            <Footer></Footer>
        </div>

    );
};

export default Reembolso;

